<div class="number-display__background">
  <div
         [ngClass]="isPrimary ? 'number-display__primary-number' :
                                    'number-display__secondary-number'" [attr.data-testid]="title + '-display-number'">
    @switch (format) {
      @case ('percentage') {
        <div [attr.data-testid]="number + '-number'">{{number | percent: '1.0-2'}}</div>
      }
      @case ('roundedPercentage') {
        <div [attr.data-testid]="number + '-number'">{{number | percent: '1.0-0'}}</div>
      }
      @case ('currency') {
        <div [attr.data-testid]="number + '-number'">${{number | number: '1.2-2'}}</div>
      }
      @default {
        <div [attr.data-testid]="number + '-number'">{{number}}</div>
      }
    }
  </div>
  @if (isPrimary) {
    <div class="number-display__horizontal-bar-category"></div>
    <span class="number-display__primary-title">{{title}}</span>
  }
  @if (!isPrimary) {
    <span class="number-display__secondary-title">{{title}}</span>
  }
</div>
